/** Rótulo da versão legada (V1.2.0, desativada em 30/10/2026); só para estado antigo e testes. */
export const SMAP_VERSION_OLD = 'SmapR V1.2.0 (antiga)';

/** Rótulo da versão nova do SMAP; é a única em produção e corresponde a ck_is_nt = true. */
export const SMAP_VERSION_NEW = 'SmapR V1.4.1 (nova)';

/**
 * Converte o rótulo guardado no estado para o booleano que o backend espera em ck_is_nt.
 * Desde 30/10/2026 o backend ignora o campo (todo estudo roda na versão nova); o formulário
 * não oferece mais a escolha e o estado nasce com SMAP_VERSION_NEW.
 */
export function isSmapVersionNew(label: string): boolean {
  return label === SMAP_VERSION_NEW;
}
